import { submitErrorDialog } from '../shared';
import { openDialog } from '../store/dialog';
import { PAGE_ROUTES } from '../utils/constants';

type Dispatch = (action: unknown) => void;

type HistoryLike = {
  push: (path: string, state?: { submitted: boolean }) => void;
};

export type ApiServiceLikeHelper = {
  submitCustomer: (customer: unknown, dispatch: Dispatch) => Promise<unknown>;
};

type HandleSubmitParams = {
  disableSubmitFunc: boolean;
  apiService: ApiServiceLikeHelper;
  customer: unknown;
  dispatch: Dispatch;
  history: HistoryLike;
};

export function handleSubmit({ disableSubmitFunc, apiService, customer, dispatch, history }: HandleSubmitParams): void {
  if (!disableSubmitFunc) {
    apiService
      .submitCustomer(customer, dispatch)
      .then(() => history.push('/' + PAGE_ROUTES.tracker, { submitted: true }))
      .catch((e: { message?: string }) => {
        let errorMsg = e.message;
        let msg = '';

        if (errorMsg && errorMsg.includes('400')) {
          msg = errorMsg.replace('400', 'Invalid Form');
        }

        dispatch(openDialog(submitErrorDialog(history, `/${PAGE_ROUTES.help}`, msg)));
      });
  }
}
